<script setup lang="ts">
  import type { Nullish } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{ message?: string | Nullish }>()
</script>

<template>
  <p
    class="validation-message"
    :class="{ visible: !!message }"
    role="alert"
    :data-validation-error="!!message"
  >
    {{ message }}
  </p>
</template>

<style scoped>
  .validation-message {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    color: var(--colours-support-negative);
    font-size: 15px;
    margin: 0.25rem 0 0.5rem 0;
    opacity: 0;
    height: 0;
    overflow: hidden;
    transition: opacity 0.15s;
  }

  .validation-message.visible {
    opacity: 1;
    height: auto;
  }
</style>
